(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesController', ScriptsReleasesController);

    ScriptsReleasesController.$inject = ['$state', 'ScriptsReleases', 'TabObjectTypes','ParseLinks', 'AlertService', 'pagingParams', 'ScriptsTypes'];

    function ScriptsReleasesController ($state, ScriptsReleases, TabObjectTypes, ParseLinks, AlertService, pagingParams, ScriptsTypes) {
        var vm = this;
        vm.scriptsReleases = [];
        vm.scriptsReleasesInactive = [];
        vm.predicates = {};
        vm.page = 0;
        vm.currentState = "tab-device-releases";
        vm.charToSearch = pagingParams.search;
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        vm.scriptTypes = {};
        vm.scriptTypes.id = pagingParams.scriptsTypes;
        vm.loadFilters = loadFilters;
        vm.loadFilters();

        function loadFilters() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            ScriptsTypes.query({
                page: 0,
                size: 1000
            }, onSuccessDevice, onError);

            function onSuccessDevice(data) {
                vm.scriptsTypes = data;
                vm.scriptsTypes.unshift({
                    id: -1,
                    scriptsTypeName: 'All'
                });
                vm.scriptsTypes.forEach(function (value) {
                    if (value.id == pagingParams.scriptsTypes) {
                        vm.scriptTypes = value;
                    }
                });
            }

            function onError() {
            }
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function(notify) {
            var page = {
                page: vm.page,
                size: 20,
                sort: sort()
            };
            var ch = {ch: vm.charToSearch, objectType: vm.objectType.id, scriptsTypes: vm.scriptTypes.id};

            ScriptsReleases.search(page, ch, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsReleases.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);
                // transition (notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function() {
            vm.page = 0;
            vm.scriptsReleases = [];
            vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

        vm.loadInactive = function(scriptsRelease) {
            ScriptsReleases.load({name: scriptsRelease.scriptsReleaseName, idShowed : scriptsRelease.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.scriptsReleasesInactive[scriptsRelease.scriptsReleaseName] = [];
                vm.scriptsReleasesInactive[scriptsRelease.scriptsReleaseName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                objectType: vm.objectType.id,
                scriptsTypes: vm.scriptsTypes.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.scriptsReleases = [];
            vm.page = 0;
            vm.loadAll();
            transition(false);
        };

    }
})();
